var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"C-fragment C-fragment-html",class:("C-fragment-html--" + (_vm.props.content.type)),domProps:{"innerHTML":_vm._s(_vm.props.content.html)}})}
var staticRenderFns = []

export { render, staticRenderFns }